module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8fb27bc07c64def488d712e06906c7a4.svg";